import thunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import rootReducer from 'reducers';
import { aiSearchBaselineMiddleware } from 'middleware/aiSearchBaselineMiddleware';
import { searchNLPPersistenceMiddleware } from 'middleware/searchNLPPersistenceMiddleware';

const configureStore = () => {
  const withMiddleware = applyMiddleware(
    thunk,
    aiSearchBaselineMiddleware,
    searchNLPPersistenceMiddleware
  );
  const composedEnhancers = composeWithDevTools(withMiddleware);
  const store = createStore(rootReducer, composedEnhancers);

  return store;
};

export default configureStore();
